import React from 'react';
import { string, bool } from 'prop-types';
import { compose } from 'redux';
import { FormattedMessage, injectIntl, intlShape } from '../../util/reactIntl';
import { Form as FinalForm } from 'react-final-form';
import classNames from 'classnames';
import config from '../../config';
import { Form, Button, FieldTextInput, FieldCurrencyInput } from '../../components';
import * as validators from '../../util/validators';
import { propTypes } from '../../util/types';

import { maxLength, required, composeValidators } from '../../util/validators';

import { formatMoney } from '../../util/currency';
import { types as sdkTypes } from '../../util/sdkLoader';

import css from './OfferDetails.module.css';

const { Money } = sdkTypes;

const OFFER_MAX_LENGTH = 500;

const OfferDetailsComponent = props => (
  <FinalForm
    {...props}
    render={fieldRenderProps => {
      const {
        rootClassName,
        className,
        formId,
        handleSubmit,
        inProgress,
        intl,
        listingTitle,
        authorDisplayName,
        values,
        isProvider,
        invalid
      } = fieldRenderProps;

      const priceRequired = validators.required(
        intl.formatMessage({
          id: 'EditListingPricingForm.priceRequired',
        })
      );
      const minPrice = new Money(config.listingMinimumPriceSubUnits, config.currency);
      const minPriceRequired = validators.moneySubUnitAmountAtLeast(
        intl.formatMessage(
          {
            id: 'EditListingPricingForm.priceTooLow',
          },
          {
            minPrice: formatMoney(intl, minPrice),
          }
        ),
        config.listingMinimumPriceSubUnits
      );
      const priceValidators = config.listingMinimumPriceSubUnits
        ? validators.composeValidators(priceRequired, minPriceRequired)
        : priceRequired;

      const classes = classNames(rootClassName || css.root, className);
      const submitInProgress = inProgress;
      const submitDisabled = submitInProgress || invalid;

      return (
        <Form className={classes} onSubmit={handleSubmit} enforcePagePreloadFor="OrderDetailsPage">

          <h2 className={css.heading}>
            <FormattedMessage id="TransactionPanel.offerDetailsTitle" />
          </h2>

          {isProvider && (
            <p className={css.subHeading}>
              <FormattedMessage id="TransactionPanel.offerDetailsCommissionTip" />
            </p>
          )}

          <FieldTextInput
            id="price"
            name="price"
            className={css.priceInput}
            type="number"
            min="0"
            step=".01"
            label={"Price"}
            placeholder={"Enter price"}
            validate={composeValidators(
              required(intl.formatMessage({
                id: 'TransactionPanel.offerPriceRequired',
              })),
              maxLength(intl.formatMessage({
                id: 'TransactionPanel.offerDetailsMaxLength',
              }, { maxLength: 10 }), 10))
            }
            isRequired
          />
          <FieldTextInput
            id="currency"
            name="currency"
            className={css.currencyInput}
            type="text"
            label="Currency"
            placeholder="Enter currency"
            validate={composeValidators(
              required(intl.formatMessage({
                id: 'TransactionPanel.offerCurrencyRequired',
              })),
              maxLength(intl.formatMessage({
                id: 'TransactionPanel.offerDetailsMaxLength',
              }, { maxLength: 15 }), 15))
            }
            isRequired
          />

          <FieldTextInput
            id="message"
            name="message"
            className={css.textField}
            type="textarea"
            label="Message"
            placeholder="Enter your message"
            validate={composeValidators(
              required(intl.formatMessage({
                id: 'TransactionPanel.offerDetailsRequired',
              })),
              maxLength(intl.formatMessage({
                id: 'TransactionPanel.offerDetailsMaxLength',
              }, { maxLength: OFFER_MAX_LENGTH }), OFFER_MAX_LENGTH))
            }
            isRequired
          />

          <Button type="submit" inProgress={submitInProgress} disabled={submitDisabled}>
            <FormattedMessage id="TransactionPanel.sendAquote" />
          </Button>

        </Form>
      );
    }}
  />
);

OfferDetailsComponent.defaultProps = {
  rootClassName: null,
  className: null,
  submitButtonWrapperClassName: null,
  inProgress: false,
  sendEnquiryError: null,
};

OfferDetailsComponent.propTypes = {
  rootClassName: string,
  className: string,
  submitButtonWrapperClassName: string,

  inProgress: bool,

  listingTitle: string.isRequired,
  authorDisplayName: string.isRequired,
  sendEnquiryError: propTypes.error,

  // from injectIntl
  intl: intlShape.isRequired,
};

const OfferDetails = compose(injectIntl)(OfferDetailsComponent);

OfferDetails.displayName = 'OfferDetails';

export default OfferDetails;
